export default "__VITE_ASSET__YOveG5kb__"